import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { CREATOR_THEME_TOKEN } from '@/styles/theme';
import AuthLayout from '@/layouts/AuthLayout';
import LoginPage from '@/pages/login/LoginPage';
import RegisterPage from '@/pages/register/RegisterPage';
import HomePage from '@/pages/home/HomePage';
import ExperimentListPage from '@/pages/experiments/ExperimentListPage';
import ExperimentWorkbenchPage from '@/pages/experiments/ExperimentWorkbenchPage';
import BundleListPage from '@/pages/bundles/BundleListPage';
import BundleBuilderPage from '@/pages/bundles/BundleBuilderPage';
import UsageListPage from '@/pages/usage/UsageListPage';
import UsageRunPage from '@/pages/usage/UsageRunPage';
import UsageDetailPage from '@/pages/usage/UsageDetailPage';

// Wrapper that keys the workbench by experiment id so React fully unmounts /
// remounts when switching experiments. Without this, useState initializers
// (which seed referenceIds / userInputIds / prompt / etc. from localStorage)
// only run on the FIRST mount, and the auto-save effect then writes stale
// state from the previous experiment into the new experiment's draft key.
const KeyedExperimentWorkbenchPage = () => {
  const { id } = useParams<{ id: string }>();
  return <ExperimentWorkbenchPage key={id} />;
};

const App: React.FC = () => (
  <ConfigProvider locale={zhCN} theme={{ token: CREATOR_THEME_TOKEN }}>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/" element={<AuthLayout />}>
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="home" element={<HomePage />} />
          <Route path="experiments" element={<ExperimentListPage />} />
          <Route path="experiments/:id" element={<KeyedExperimentWorkbenchPage />} />
          <Route path="bundles" element={<BundleListPage />} />
          <Route path="bundles/:id" element={<BundleBuilderPage />} />
          <Route path="usage" element={<UsageListPage />} />
          <Route path="usage/new" element={<UsageRunPage />} />
          <Route path="usage/:runId" element={<UsageDetailPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  </ConfigProvider>
);

export default App;
